import React, { useEffect, useState } from "react";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Badge, message } from "antd";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { AiOutlineShoppingCart } from "react-icons/ai";
import type { RadioChangeEvent } from "antd";
import { Radio } from "antd";
import {IoIosCloseCircleOutline } from "react-icons/io";
import axios from "axios";
import { API_URL } from "../API/config";
import { Box, Modal } from "@mui/material";
import { eventManager } from "../EventEmitter";

interface Data {
  firstName: String;
  lastName: String;
  gender: String;
  email: String;
  wishlist: any[];
  cart: any[];
  shippingAddress: {
    addressType: string;
    alternateNumber: string;
    buildingAndBlockNumber: string;
    email: string;
    firstName: string;
    houseNumberAndFloor: string;
    landmark: string;
    lastName: string;
    locality: string;
    phoneNumber: string;
    pincode: string;
  };
}

export default function NavbarComponent() {
  const [isFav, setIsFav] = useState(false);
  const [profile, setProfile] = useState(false);
  const [isUser, setIsuser] = useState(false);
  const [value, setValue] = useState("male");
  const [firstName, setFirstname] = useState("");
  const [data, setData] = useState<Data>();
  const token = sessionStorage.getItem("token");

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    gender: "male",
    email: sessionStorage.getItem("userEmail") || "", 
  });

  const handleupdateuser = async () => {

    try {
      if(!token){
        message.error("Please Login again!")
        return
      }
      if(!userData.firstName||!userData.lastName){
        message.error("Fill required fields!")
        return
      }
      const res = await axios.patch(
        `${API_URL}/api/user/updateUser`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // window.location.reload();
      message.success("Profile updated successfully!");
      setIsuser(false);
      await getUser();
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const getUser = async () => {
    const token = sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      sessionStorage.setItem("userEmail",res.data.user.email)
      setData(res.data.user);
      const user = res.data.user;
      setUserData((prev) => ({
        ...prev,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        gender: user.gender,
      }));
      setFirstname(res.data.user.firstName);
    } catch (error: any) {
      console.log(error);
    }
  };

  const onChange = (e: RadioChangeEvent) => {
    console.log(e.target.value);
    setUserData({ ...userData, gender: e.target.value });
    setValue(e.target.value);
  };


  const handleFav = () => {
    setIsFav(true);
    setProfile(false);
  };

  const handleUserProfile = () => {
    setIsFav(false);
    setProfile(true);
  };

  const handleCart = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if(!token){
      message.error("Login required!")
      return
    }
        try {
      const cartData = {
        productId: data.product,
        variantDetails: {
          storage: data.variant.storage,
          colorName: data.variant.colorName,
          ramSize: data.variant.ramSize,
        },
      };
      await axios.post(`${API_URL}/api/user/cart`, cartData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      await getUser();
      await handleRemovewishList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemovewishList = async (data: any) => {
       const token = sessionStorage.getItem("token");
       if(!token){
         message.error("Login required!")
         return
       }
    try {
      const wishData = {
        productId: data.product,
        variantId: data.variantId,
      };

      await axios.delete(`${API_URL}/api/user/wishlist/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: wishData,
      });

      await getUser();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseBox = () => {
    setProfile(false);
    setIsuser(false);
  };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    eventManager.on("cartUpdated", getUser);

    return () => {
      eventManager.off("cartUpdated", getUser);
    };
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
    handleUserProfile();
  };
  const handleClose = () => setOpen(false);


  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);
  const closeNavbar = () => setShow(false);

  return (
    <Navbar expand="lg" className="navbar py-0">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav ms-auto" onClick={handleToggle}/>
        <div id="basic-navbar-nav" className="d-block d-lg-none">
          <Link to={"/"}>
            <img src="/logo.png" className="img-fluid logo me-3" alt="logo" />
          </Link>
        </div>
        <div className="d-flex d-lg-none">
          <div className="link me-4">
            <Link to="/orders">
              <i
                className="fi fi-rr-shopping-bag icons"
                onClick={() => setIsFav(false)}
              ></i>
            </Link>
          </div>
          <div className="position-relative">
            <i className="fi fi-rr-user icons" onClick={handleOpen}></i>
          </div>
        </div>
        <Navbar.Collapse id="basic-navbar-nav nav-flex" in={show}>
          <Nav className="homenav">
            {/* Left Section with Navigation Links */}
            <Link to="/" className="nav-navi" onClick={closeNavbar}>
              Home
            </Link>
            {/* <Link to="/product1" className="nav-navi brandsma">
              Product
            </Link> */}
            <Link to="/offers" className="nav-navi brandsma" onClick={closeNavbar}>
              Offers
            </Link>
            <Link to="/product/smart-phone" className="nav-navi  " onClick={closeNavbar}> 
              Product
            </Link>
            <a
              className="nav-navi d-block d-lg-none"
              onClick={() => setIsFav(true)}
            >
              Favourite
            </a>
            <Link to="/cart" className="nav-navi d-block d-lg-none" onClick={closeNavbar}>
              Cart
            </Link>
          </Nav>

          <div className="d-lg-none">
            {isFav && (
              <>
                <img className="polygon d-none" src="/assets/Polygon.png" />
                <div className="fav">
                  <div className="">
                    <div className="d-flex justify-content-between align-items-center pb-3">
                      <h3>Favotites</h3>
                      <IoIosCloseCircleOutline
                        style={{ cursor: "pointer" }}
                        className="fs-5"
                        onClick={() => setIsFav(false)}
                      />
                    </div>
                    {(data?.wishlist || []).length > 0
                      ? data?.wishlist.map((val, i) => (
                          <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                              <div className="fav-img">
                                <img
                                  className="img-fluid"
                                  src="/assets/phone.png"
                                />
                              </div>
                            </div>
                            <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                              <div className="fav-content">
                                <h5>
                                  Samsung Galaxy A30S 5G{" "}
                                  {`(${val.variant.ramSize},${val.variant.storage},${val.variant.colorName})`}
                                </h5>
                                {/* <p>
                                  <span className="fav-p">₹ {val.price}</span>
                                  <span className="mx-2">
                                    M.R.P : ₹{" "}
                                    <span
                                      style={{ textDecoration: "line-through" }}
                                    >
                                      20,499.00
                                    </span>
                                  </span>
                                  <span style={{ color: "#2FB300" }}>10%</span>
                                </p> */}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                              <div className="d-flex justify-content-start align-items-center">
                                <Button
                                  className="cart-button me-3"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleCart(val)}
                                >
                                  <AiOutlineShoppingCart />
                                </Button>
                                <Button
                                  className="cart-button"
                                  onClick={() => handleRemovewishList(val)}
                                >
                                  <MdDeleteForever />
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Logo Section */}
          <Navbar.Brand className="mx-auto d-none d-lg-block" href="/">
            <img src="/logo.png" className="img-fluid logo me-3" alt="logo" />
          </Navbar.Brand>

          {/* Right Section with Icons */}
          <Nav className="homenav gap-4 d-none d-lg-flex">
            <div className="position-relative">
              <Badge count={data?.wishlist.length}>
                <i className="fi fi-rr-heart icons" onClick={handleFav}></i>
              </Badge>
              {isFav && (
                <>
                  <img className="polygon" src="/assets/Polygon.png" />
                  <div className="fav">
                    <div className="">
                      <div className="d-flex justify-content-between align-items-center pb-3">
                        <h3>Favotites</h3>
                        <IoIosCloseCircleOutline
                          style={{ cursor: "pointer" }}
                          className="fs-5"
                          onClick={() => setIsFav(false)}
                        />
                      </div>
                      {(data?.wishlist || []).length > 0 ? (
                        data?.wishlist.map((val, i) => (
                          <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                              <div className="fav-img">
                                <img
                                  className="img-fluid"
                                  src="/assets/phone.png"
                                />
                              </div>
                            </div>
                            <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                              <div className="fav-content">
                                <h5>
                                  Samsung Galaxy A30S 5G{" "}
                                  {`(${val.variant.ramSize},${val.variant.storage},${val.variant.colorName})`}
                                </h5>
                                <p>
                                  <span className="fav-p">
                                    ₹ {val.variant.dealPrice}
                                  </span>
                                  <span
                                    className="ms-2"
                                    style={{ textDecoration: "line-through" }}
                                  >
                                    MRP ₹ {val.variant.price}
                                  </span>
                                  <span
                                    className="ms-2"
                                    style={{ color: "green" }}
                                  >
                                    Save ₹{" "}
                                    {val.variant.price - val.variant.dealPrice}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                              <div className="d-flex justify-content-start align-items-center">
                                <Button
                                  className="cart-button me-3"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleCart(val)}
                                >
                                  <AiOutlineShoppingCart />
                                </Button>
                                <Button
                                  className="cart-button"
                                  onClick={() => handleRemovewishList(val)}
                                >
                                  <MdDeleteForever />
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-5">
                          <img
                            src="/assets/favd.png"
                            className="img-fluid"
                            style={{ width: "100px" }}
                          />
                          <p style={{ fontWeight: 600 }}>No favorites yet</p>
                          <Link to={"/"}>
                            <Button
                              variant="outlined"
                              className="explorebtn"
                              onClick={() => setIsFav(false)}
                            >
                              Continue Shopping
                            </Button>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* <div className="position-relative">
              <i className="fi fi-rr-marker icons" onClick={handleLocenter}></i>
              {isLoc && (
                <>
                  <img className="polygon" src="/assets/Polygon.png" />
                  <div className="fav">
                    {!isAddress ? (
                      <div className="">
                        <div className="d-flex justify-content-between align-items-center pb-3">
                          <h3>My Address</h3>
                          <IoIosCloseCircleOutline
                            style={{ cursor: "pointer" }}
                            className="fs-5"
                            onClick={() => setIsloc(false)}
                          />
                        </div>
                        <div className="row address">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                House no & Floor{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Building & Block no{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Locality <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Pin Code <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Phone No <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Email id <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Alternate Number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Landmark <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input />
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div>
                              <label>Address Type</label>
                              <br />
                              <Radio.Group onChange={onChange} value={value}>
                                <Radio value={1}>Home</Radio>
                                <Radio value={2}>Work</Radio>
                                <Radio value={3}>Other</Radio>
                              </Radio.Group>
                            </div>
                          </div>
                          <div className="text-center py-3">
                            <Button
                              className="save"
                              onClick={() => setIsaddress(true)}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3>My Address</h3>
                          <div>
                            <span
                              style={{
                                border: "1px solid #000",
                                padding: "3px 10px",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() => setIsaddress(false)}
                            >
                              ADD{" "}
                              <IoIosAddCircleOutline
                                style={{ fontSize: "24px", cursor: "pointer" }}
                              />
                            </span>
                            <IoIosCloseCircleOutline
                              className="ms-3"
                              style={{ cursor: "pointer", fontSize: "24px" }}
                              onClick={() => setIsloc(false)}
                            />
                          </div>
                        </div>
                        <div className="mt-4 add-box">
                          <div className="d-flex justify-content-between align-items-center">
                            <h3>Address 1</h3>
                            <div>
                              <MdEdit
                                className="me-3 fs-5"
                                style={{ cursor: "pointer" }}
                              />
                              <MdDeleteForever
                                className="fs-5"
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </div>
                          <p className="mb-0">
                            Johnson S , johnsn@gmail.com , 78451 27845
                          </p>
                          <p className="mb-0">
                            13 , High road street , main block near church
                            street , Chennai , Tamil Nadu India{" "}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div> */}
            <div className="link d-none d-lg-block">
              <Link to="/orders">
                <i
                  className="fi fi-rr-shopping-bag icons"
                  onClick={() => setIsFav(false)}
                ></i>
              </Link>
            </div>
            <div className="link">
              <Link to="/cart">
                <Badge count={data?.cart.length}>
                  <i
                    className="fi fi-rr-shopping-cart icons"
                    onClick={() => setIsFav(false)}
                  ></i>
                </Badge>
              </Link>
            </div>
            <div className="position-relative  d-none d-lg-block">
              <i
                className="fi fi-rr-user icons"
                onClick={handleUserProfile}
              ></i>
              {profile && (
                <>
                  <img className="polygon" src="/assets/Polygon.png" />
                  <div className="favaddress">
                    {firstName && isUser === false ? (
                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3>My Profile </h3>
                          <div>
                            <MdEdit
                              style={{ fontSize: "24px", cursor: "pointer" }}
                              onClick={() => setIsuser(true)}
                            />
                            <IoIosCloseCircleOutline
                              className="ms-3"
                              style={{ cursor: "pointer", fontSize: "24px" }}
                              onClick={() => {setProfile(false)
                                handleCloseBox()
                              }}
                            />
                          </div>
                        </div>
                        <div className="">
                          <table>
                            <tr>
                              <th>First Name</th>
                              <td>{data?.firstName}</td>
                            </tr>
                            <tr>
                              <th>Last Name</th>
                              <td>{data?.lastName}</td>
                            </tr>
                            <tr>
                              <th>Email id</th>
                              <td>{data?.email}</td>
                            </tr>
                            {/* <tr>
                              <th>Gender</th>
                              <td>{data?.gender}</td>
                            </tr> */}
                          </table>
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        <div className="d-flex justify-content-between align-items-center pb-3">
                          <h3>My Profile</h3>
                          <IoIosCloseCircleOutline
                            style={{ cursor: "pointer" }}
                            className="fs-5"
                            onClick={handleCloseBox}
                          />
                        </div>
                        <div className="row address">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input
                                value={String(
                                  userData?.firstName ? userData?.firstName : ""
                                )}
                                onChange={(e: any) =>
                                  setUserData({
                                    ...userData,
                                    firstName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div>
                              <label>
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <br />
                              <input
                                value={String(
                                  userData?.lastName ? userData?.lastName : ""
                                )}
                                onChange={(e: any) =>
                                  setUserData({
                                    ...userData,
                                    lastName: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div>
                              <label>Gender</label>
                              <br />
                              <Radio.Group
                                onChange={onChange}
                                value={value}
                              >
                                <Radio value={"male"}>Male</Radio>
                                <Radio value={"female"}>Female</Radio>
                                <Radio value={"other"}>
                                  Prefer not to answer
                                </Radio>
                              </Radio.Group>
                            </div>
                          </div> */}
                          <div className="text-center py-3">
                            <Button className="save" onClick={handleupdateuser}>
                              Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </Nav>
        </Navbar.Collapse>

        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <>
                <img className="polygon" src="/assets/Polygon.png" />
                <div className="">
                  {firstName && isUser === false ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center">
                        <h3>My Profile </h3>
                        <div>
                          <MdEdit
                            style={{ fontSize: "24px", cursor: "pointer" }}
                            onClick={() => setIsuser(true)}
                          />
                          <IoIosCloseCircleOutline
                            className="ms-3"
                            style={{ cursor: "pointer", fontSize: "24px" }}
                            onClick={() => setProfile(false)}
                          />
                        </div>
                      </div>
                      <div className="">
                        <table>
                          <tr>
                            <th>First Name</th>
                            <td>{data?.firstName}</td>
                          </tr>
                          <tr>
                            <th>Last Name</th>
                            <td>{data?.lastName}</td>
                          </tr>
                          <tr>
                            <th>Email id</th>
                            <td>{data?.email}</td>
                          </tr>
                          {/* <tr>
                              <th>Gender</th>
                              <td>{data?.gender}</td>
                            </tr> */}
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="">
                      <div className="d-flex justify-content-between align-items-center pb-3">
                        <h3>My Profile</h3>
                        <IoIosCloseCircleOutline
                          style={{ cursor: "pointer" }}
                          className="fs-5"
                          onClick={handleClose}
                        />
                      </div>
                      <div className="row address">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div>
                            <label>
                              First Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <br />
                            <input
                              value={String(userData?.firstName)}
                              onChange={(e: any) =>
                                setUserData({
                                  ...userData,
                                  firstName: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div>
                            <label>
                              Last Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <br />
                            <input
                              value={String(userData?.lastName)}
                              onChange={(e: any) =>
                                setUserData({
                                  ...userData,
                                  lastName: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                          <div>
                            <label>Gender</label>
                            <br />
                            <Radio.Group onChange={onChange} value={value}>
                              <Radio value={"male"}>Male</Radio>
                              <Radio value={"female"}>Female</Radio>
                              <Radio value={"other"}>
                                Prefer not to answer
                              </Radio>
                            </Radio.Group>
                          </div>
                        </div> */}
                        <div className="text-center py-3">
                          <Button className="save" onClick={handleupdateuser}>
                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            </Box>
          </Modal>
        </div>
      </Container>
    </Navbar>
  );
}
